<template>
  <!-- 自配拒单 详情 -->
  <div class="match-refuse">
    <div class="table-list">
      <el-table :data="orderDetailTableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"> </el-table-column>
        <el-table-column prop="order_number" label="子订单号" width="140">
        </el-table-column>
        <el-table-column prop="ruigu_code" label="锐锢编码"> </el-table-column>
        <el-table-column prop="self_code" label="三方商品编码"> </el-table-column>
        <el-table-column prop="name" label="商品名" width="280">
        </el-table-column>
        <el-table-column prop="spec" label="规格"> </el-table-column>
        <el-table-column prop="unit" label="单位"> </el-table-column>
        <el-table-column prop="send_amount" label="实发数量"> </el-table-column>
        <el-table-column prop="re_num" label="收货数量"> </el-table-column>
        <el-table-column prop="cfm_num" label="确认数量" width="140"> 
          <template slot-scope="scope">
            <el-input v-model="scope.row.cfm_num" placeholder=""></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="异常原因" width="140"> 
          <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder=""></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
   
    <div class="tool-btn">
        <el-button size="small" type="primary" @click="handleSave">保存</el-button>
    </div>

    <!-- 弹窗 确认 拒绝 -->
    <el-dialog
      :visible.sync="refuseDialogVisible"
      :append-to-body="true"
      center
      width="500px"
      custom-class="confirm-refuse-dialog"
      title="确认提示"
    >
      <p>信息确认后，将作为扣款处理的依据！</p>
      <p slot="footer" class="dialog-footer">
        <el-button @click="refuseDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleConfirm(true)" size="mini">确 定</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { r4MatchRefuseOrderSure, getR4MatchRefuseLisDetail } from "@/models/orderModel";
import debounce from 'lodash/debounce';
export default {
  data() {
    this.handleConfirm = debounce(this.handleConfirm, 800);
    return {
      orderDetailTableData: [],
      refuseDialogVisible: false,
    };
  },
  created() {
    this.initRefuseOrderDetail();
  },
  methods: {
    // 获取订单详情
    async initRefuseOrderDetail() {
      const { re_order_id } = this.$route.query;
      let params = {
        re_order_id,
      };
      const res = await getR4MatchRefuseLisDetail(params);
      this.orderDetailTableData = res;
    },
    // 保存
    handleSave() {
      let emptyFlag = this.orderDetailTableData.every(item => {
        if(item.cfm_num && Number(item.cfm_num) > 0 && Number(item.cfm_num) == Number(item.re_num)) { 
          return item;
        }
      });
      if(emptyFlag){
        this.refuseDialogVisible = true;
      } else {
        this.$message.warning('确认数量需等于收货数量！')
      }
    },
    // 确认 提交
    handleConfirm() {
      const { re_order_id } = this.$route.query;
      const data = [];
      this.orderDetailTableData.map(item => {
        data.push({
          id: item.id,
          order_number: item.order_number,
          cfm_num: item.cfm_num,
          remark: item.remark
        })
      })
      let params = {
        token: localStorage.getItem('token'),
        shop_id: localStorage.getItem('shop_id'),
        re_order_id: re_order_id,
        data: JSON.stringify(data)
      };
      //console.log(params, 'params');
      r4MatchRefuseOrderSure(params).then(res => {
        this.$message.success('操作成功');
        this.refuseDialogVisible = false;
        this.$router.push({
          path: "/order/manage",
        });
      }).catch(error => {
        this.refuseDialogVisible = false;
        this.$message.error(error.message);
      })
    }
  },
};
</script>
<style lang="scss">
  .match-refuse {
    .table-list {
      margin-top: 20px;
      .el-table__body-wrapper {
        .el-table__body{
          .el-table__row{
            height: 40px;
            .el-input {
              .el-input__inner{
                width: 100px;
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
    .tool-btn{
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/matchRefuse.vue